import { render } from "./DrillHolePresetIcon.vue?vue&type=template&id=0c4d4169"
import script from "./DrillHolePresetIcon.vue?vue&type=script&lang=js"
export * from "./DrillHolePresetIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__